import Vue from 'vue'
import VueRouter from 'vue-router'

// 懒加载组件
const HomeView = () => import('@/views/home/index.vue')
const NotFoundView = () => import('@/views/notFound/index.vue')
// 用户提交信息
const SubmitUserInfo = () => import('@/views/submitUserInfo/index.vue')
// 业务模式
const VcModel = () => import('@/views/vcModel/index.vue')

// 关于我们
const AboutUs = () => import('@/views/aboutUs/index.vue')


// 立即入驻
const SettledPlatform = () => import('@/views/settledPlatform/index.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { title: 'HARMONY GLOBAL | 寰美国际' }
  },
  {
    path: '/submitUserInfo',
    name: 'SubmitUserInfo',
    component: SubmitUserInfo
  },
  {
    path: '/vcModel',
    name: 'VcModel',
    component: VcModel
  },
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/settledPlatform',
    name: 'SettledPlatform',
    component: SettledPlatform
  },
  {
    // 404页面
    path: '*',
    name: 'NotFound',
    component: NotFoundView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 完成导航
  next();
});

export default router
